import Vue from "vue";
import VueRouter from "vue-router";
import Home from "./views/Home.vue";
import App from "./App.vue";
import vueScrollto from "vue-scrollto";

// const WJ = () => import("./views/WJ.vue");
// const KK = () => import("./views/KK.vue");
// const JG = () => import("./views/JG.vue");
const DCKL = () => import("./views/DCKL.vue");

Vue.config.productionTip = false;
Vue.use(vueScrollto);

Vue.use(VueRouter);

const routes = [
  // {
  //   path: "/",
  //   name: "DCKL",
  //   meta: {
  //     title: "Kancelaria Adwokacka DCKL Czerwińska Lipiński",
  //     metaTags: [
  //       {
  //         name: "keywords",
  //         content:
  //           "Kancelaria Adwokacja JKG Jurgowiak, Kaźmierczak, Giezek, Kancelaria JKG, JKG, Kancelaria Adwokacja, Kancelaria Adwokacka Wrocław."
  //       }
  //     ]
  //   },
  //   component: DCKL,
  //   params: { language: ":language", t: ":t" }
  // },
  // {
  //   path: "/wj",
  //   name: "wj",
  //   meta: {
  //     title: "Kancelaria Adwokacka JKG Adwokat Wojciech Jurgowiak"
  //   },
  //   component: WJ,
  //   params: { language: ":language", t: ":t" }
  // },
  // {
  //   path: "/kk",
  //   name: "kk",
  //   meta: { title: "Kancelaria Adwokacka JKG Adwokat Krzysztof Kaźmierczak" },
  //   component: KK,
  //   params: { language: ":language", t: ":t" }
  // },
  // {
  //   path: "/jg",
  //   name: "jg",
  //   meta: { title: "Kancelaria Adwokacka JKG Adwokat Jacek Giezek" },
  //   component: JG,
  //   params: { language: ":language", t: ":t" }
  // },
  {
    path: "/",
    name: "dckl",
    meta: { title: "Czerwińska, Lipiński Kancelaria Adwokacka s. c." },
    component: DCKL,
    params: { language: ":language", t: ":t" }
  },
  {
    path: "*",
    redirect: "/"
  }
];

const router = new VueRouter({
  routes,
  mode: "history",
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.metaTags);
  const previousNearestWithMeta = from.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll("[data-vue-router-controlled]")).map(el =>
    el.parentNode.removeChild(el)
  );

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags
    .map(tagDef => {
      const tag = document.createElement("meta");

      Object.keys(tagDef).forEach(key => {
        tag.setAttribute(key, tagDef[key]);
      });

      // We use this to track which meta tags we create, so we don't interfere with other ones.
      tag.setAttribute("data-vue-router-controlled", "");

      return tag;
    })
    // Add the meta tags to the document head.
    .forEach(tag => document.head.appendChild(tag));

  next();
});

new Vue({
  router,
  render: h => h(App)
}).$mount(".app");
